import React from 'react';
import { useField } from 'react-final-form';
import { useSelector } from 'react-redux';

import { select } from '@swf/core/store';

import { TaxCodeType } from '../../../../../../../../validators/taxCode';
import DocumentTypeField from '../../../../../RMFDocumentation/components/DocumentTypeField/DocumentTypeField';
import TaxCodeField from '../TaxCodeField/TaxCodeField';

const GRFields: React.FC = () => {
  const signupCountry = useSelector(select.account.getCountry);

  const {
    input: { value: country }
  } = useField('country', { initialValue: signupCountry });

  const {
    input: { value: citizenship }
  } = useField('citizenship', { subscription: { value: true }, initialValue: signupCountry });

  return (
    <>
      <DocumentTypeField country={country} citizenship={citizenship} />
      <TaxCodeField taxCodeType={TaxCodeType.NONE} />
    </>
  );
};

export default GRFields;
